import { render, staticRenderFns } from "./inter-iframe.vue?vue&type=template&id=5d094425&"
import script from "./inter-iframe.vue?vue&type=script&lang=js&"
export * from "./inter-iframe.vue?vue&type=script&lang=js&"
import style0 from "./inter-iframe.vue?vue&type=style&index=0&id=5d094425&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports